import { gql } from '../../../../../../../hooks/useQuery'

export const GET_MASSIVE_SAMPLES = gql`
  query GetMassiveSamples {
    t2MassiveSamples {
    }
  }
`
